
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireDirection as ObiWireDirectionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-direction.js';
 
 
 

 
 export const ObiWireDirection = createComponent({
   react: React,
   tagName: 'obi-wire-direction',
   elementClass: ObiWireDirectionElement,
   events: {
     
   }
  });
 
 